import { Component, OnInit, Inject, DestroyRef, inject } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { FileDocument } from "../models/file-document.model";
import { FileDocumentMetadata } from "../models/file-document-metadata.model";
import { MessageService } from "../../shared/errorHandler/message.service";
import { ClipboardService } from "ngx-clipboard";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  standalone: false,
  selector: "app-file-document-metadata",
  templateUrl: "./file-document-metadata.component.html",
  styles: [`
    .meta-value {
      font-size: 18px !important;
      font-weight: 700;
    }

    .metadata-state-item {
      min-height: 40px !important;
      height: auto !important;
    }

    .metadata-state-item app-file-document-state {
      width: 100%;
    }
  `],
})
export class FileDocumentMetadataComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  headerCreatedByMessageInfo = "";
  otrosMetadatos: boolean = false;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      doc: FileDocument;
      showOtrosMetadatos: boolean;
    },
    private msjService: MessageService,
    private clipboardService: ClipboardService,
    private readonly bottomSheetRef: MatBottomSheetRef<FileDocumentMetadataComponent>,
    private readonly translocoService: TranslocoService
  ) {
    this.otrosMetadatos = data.showOtrosMetadatos;
    const resp =
      this.data.doc.createdByFirstName !== null &&
      this.data.doc.createdByFirstName !== undefined;
    if (resp) {
      this.headerCreatedByMessageInfo = ' - ' + this.translocoService.translate('fileDocuments.fileDocumentMetadata.createdByLbl', {
        name: `${this.data.doc.createdByFirstName} ${this.data.doc.createdByLastName}`
      });
    } else {
      this.headerCreatedByMessageInfo = "";
    }
  }

  ngOnInit() {
    this.clipboardService.copyResponse$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      if (res.isSuccess) {
        this.msjService.showInfo(res.content + " " + this.translocoService.translate('common.copiedLbl'));
      }
    });
  }

  cancel() {
    this.bottomSheetRef.dismiss();
  }

  metadataIcon(meta: FileDocumentMetadata): string {
    switch (meta.metadataType) {
      case "text":
        return "fa-font";
        break;
      case "number":
        return "fa-hashtag";
        break;
      case "comboKV":
        return "fa-table";
        break;
      case "date":
        return "fa-calendar";
        break;
      default:
        return "fa-info-circle";
    }
  }
}
